import styled from 'styled-components/macro'
import { MENU, BREAK_ } from 'constants'
import { sb } from 'styles/styles.scrollbar'

export const Content = styled.main`
    overflow: auto;
  ${ ({styles}) => styles }
  ${ BREAK_.md_dn } {
    // height: calc(100% - 119px);
    ${ ({styles}) => styles }
  }
  ${ BREAK_.md_up } {
     padding-left: ${({ right, viewMode }) =>
      viewMode === "split" && right ? `${MENU.DESKTOP_SPLIT_VIEW_LIST_DRAWER_W}vw` : '0px'};
    padding-right: ${({right, viewMode }) =>
      viewMode === "normal" && right ? MENU.DESKTOP_UNIT_DRAWER_W : 0}px;
  };
  /* ${ BREAK_.md_dn } {
    margin-top: ${({y}) => y > 30 ? 0 : `${ MENU.MOBILE_NAV_H }px`};
    height: ${({y}) => y > 30 ? '100%' : `calc(100% - ${ MENU.MOBILE_NAV_H }px )`};
  }; */
  
  transition: 
    padding-left 0.3s ease 0.3s, /* delay by 300ms */
  padding-right 0.3s ease 0.3s,
  margin-top 0.3s ease 0.3s,
  margin-left 0.3s ease 0.3s,
  height 0.3s ease 0.3s,
  width 0.3s ease 0.3s;
`

export const Root = styled.div`
  /* display: flex; */
  /* flex-direction: row;
${BREAK_.md_dn} {
  flex-direction: column;
} */
  isolation: isolate;
  width: 100%;
  height: 100%;
  overflow-y:scroll;
  ${ sb.hide };
  /* border: 10px solid yellow; */
  /* overflow:hidden; */
  /* position: relative; */
`